import { useState, useEffect } from 'react';
import { apiClient } from '../services/apiClient';

export const useSubRoles = (role) => {
  const [subRoles, setSubRoles] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchSubRoles = async () => {
      if (!role) {
        setSubRoles([]);
        setLoading(false);
        return;
      }

      try {
        const data = await apiClient.get(`/api/roles/sub-roles/${role}`);
        setSubRoles(data);
        setError(null);
      } catch (err) {
        console.error('Error fetching sub-roles:', err);
        setError(err.message);
        setSubRoles([]);
      } finally {
        setLoading(false);
      }
    };

    fetchSubRoles();
  }, [role]);

  return { subRoles, loading, error };
}; 